import queryString from 'query-string';
import { useConnect } from '@lore/query-connect';

export default function useQuery(props) {
  const {
    location = {},
    PAGE_SIZE = 12,
    returnCsvQuery = false } = props;

  const query = {
    where: {
      eager: {
        $where: {
          firstName: {
            $not: ''
          },
          zipCode: {
            $not: ''
          },
          networkId: {
            $null: true
          }
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  };

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    // this probably does not work
    return query;
  }

  return result;
}
